import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { LandingChain } from '@box-types';
import { LandingPageService } from '@box-pages/pages/landing/landing-page.service';
import { Mousewheel, Navigation } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import { AnalyticsService } from '@box-core/services';

@Component({
  selector: 'landing-chains',
  templateUrl: './landing-chains.component.html',
  styleUrls: ['./landing-chains.component.scss']
})
export class LandingChainsComponent implements OnInit {
  @ViewChild('nextBtn', { static: true }) private nextBtn: MatButton;
  @ViewChild('prevBtn', { static: true }) private prevBtn: MatButton;

  @Input() public landingChains: LandingChain[] = [];

  public swiperOptions: SwiperOptions;

  constructor(
    private landingPageService: LandingPageService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.setSwiperOptions();
  }

  public onSelectChain(chain: LandingChain, index: number): void {
    if (!chain.slug) return;
    this.analyticsService.updatePurchaseEvent(chain._id, {
      index,
      itemListName: chain.key,
      creativeSlot: 'landing_chains',
      promotionName: chain.name
    });
    this.landingPageService.navigateTo({
      commands: ['delivery-chains', 'menu', chain.slug]
    });
  }

  private setSwiperOptions(): void {
    const nextEl: HTMLElement = (this.nextBtn._elementRef as ElementRef<HTMLButtonElement>).nativeElement;
    const prevEl: HTMLElement = (this.prevBtn._elementRef as ElementRef<HTMLButtonElement>).nativeElement;
    this.swiperOptions = {
      modules: [Navigation, Mousewheel],
      navigation: { nextEl, prevEl },
      mousewheel: { forceToAxis: true, releaseOnEdges: false },
      slidesPerView: 'auto',
      grabCursor: true,
      watchSlidesProgress: true
    };
  }
}
